/* Carrousel Video (reels) - moteur (theme 4) : titre machine a ecrire + centrage + milieu agrandi/lecture (autoplay muet uniquement au centre) + points ronds. */
(function(){
  function initSlider(root){
    if(root.dataset.hfInit) return; root.dataset.hfInit='1';

    /* -- Titre machine a ecrire -- */
    (function(){
      var dyn=root.querySelector('[data-hf-typewriter]');
      var wordEls=[].slice.call(root.querySelectorAll('.hf-typewriter-word'));
      if(!dyn||!wordEls.length) return;
      var words=wordEls.map(function(w){ return w.getAttribute('data-word')||w.textContent; });
      var speed=parseInt(root.dataset.typeSpeed||'80',10);
      var hold=parseInt(root.dataset.typeHold||'1600',10);
      var erase=Math.max(30,Math.round(speed*0.5));
      var wi=0,ci=0,deleting=false,started=false;
      function tick(){
        var word=words[wi];
        if(!deleting){ ci++; dyn.textContent=word.slice(0,ci);
          if(ci>=word.length){ deleting=true; return setTimeout(tick,hold); } setTimeout(tick,speed);
        } else { ci--; dyn.textContent=word.slice(0,ci);
          if(ci<=0){ deleting=false; wi=(wi+1)%words.length; return setTimeout(tick,speed); } setTimeout(tick,erase); }
      }
      function startTw(){ if(started) return; started=true; tick(); }
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting) startTw(); }); },{threshold:.35}).observe(dyn);
        setTimeout(startTw, 1400);
      } else { tick(); }
    })();

    /* -- Carrousel -- */
    var list=root.querySelector('[data-hf-list]');
    var slides=[].slice.call(root.querySelectorAll('[data-hf-slide]'));
    if(!list||!slides.length) return;
    var realCount=slides.length;
    var realSlides=slides;
    var pvDesk=parseFloat(root.dataset.perViewDesktop||'5');
    /* La boucle doit s'activer des qu'il y a de quoi defiler sur N'IMPORTE QUEL
       format, pas seulement le desktop : avec 5 videos et 5 visibles en
       desktop (pvDesk), "realCount>pvDesk" est FAUX alors que sur mobile
       (per_view_mobile ~1.5) il y a largement de quoi scroller. Sans boucle,
       aucun clone n'est cree : pas de defilement infini, et la derniere
       carte n'a plus rien apres elle pour la recentrer. */
    var loop=(root.dataset.loop==='true') && realCount>1;
    var currentEl=null, pinned=null;

    slides.forEach(function(s,i){ s.dataset.realIndex=String(i); });

    function isMobile(){ return window.matchMedia('(max-width:749px)').matches; }
    function perView(){ return isMobile()?parseFloat(root.dataset.perViewMobile||'1.5'):pvDesk; }
    function gap(){ return isMobile()?parseFloat(root.dataset.gapMobile||'15'):parseFloat(root.dataset.gapDesktop||'15'); }
    function sizeSlides(){ var n=perView(),g=gap(); var cs=getComputedStyle(list); var content=list.clientWidth-(parseFloat(cs.paddingLeft)||0)-(parseFloat(cs.paddingRight)||0); root.style.setProperty('--hf-vs-slide-w', ((content-g*(n-1))/n)+'px'); }
    function allChildren(){ return [].slice.call(list.children); }

    /* scroll-snap mandatory + scroll-behavior smooth bloquent le defilement programme (Chrome) : on coupe le snap et on anime nous-memes */
    list.style.scrollBehavior='auto';
    var snapTimer, animId;
    function restoreSnap(){ clearTimeout(snapTimer); list.style.scrollSnapType=''; }
    function withoutSnap(fn){ list.style.scrollSnapType='none'; fn(); clearTimeout(snapTimer); snapTimer=setTimeout(restoreSnap,1000); }
    function animateScrollLeft(target, dur){
      if(animId) clearInterval(animId);
      var start=list.scrollLeft, delta=target-start, t0=Date.now();
      animId=setInterval(function(){ var p=Math.min(1,(Date.now()-t0)/dur); var e=1-Math.pow(1-p,3); list.scrollLeft=start+delta*e; if(p>=1){ clearInterval(animId); animId=null; } }, 16);
    }

    /* Videos natives : muettes, en boucle, apercu (poster). Pas d autoplay global.
       Exception : la slide du milieu (data-hf-mid) part deja en autoplay muet
       depuis le HTML. On n y touche pas, sinon on annule ce demarrage immediat.
       IMPORTANT : preload="auto" sur TOUTES les videos (pas seulement celle du
       milieu). Avec seulement "metadata", la video ne se charge vraiment que
       lorsqu'elle devient active (tryPlay force alors v.load()) : sur un clone
       de boucle infinie, ce chargement a la volee cree le "long chargement" /
       blocage remonte par Malo, particulierement visible en scrollant vers la
       gauche (premiere zone de clones rencontree). En pre-chargeant tout des
       le depart, chaque video est deja prete quand on l'atteint, boucle ou pas. */
    /* VITESSE (16/10/2026) : le prechargement de TOUTES les videos se fait quand la
       section approche de l'ecran (marge 1200 px), plus au chargement de la page.
       Avant, les 5 videos (5,5 Mo) partaient avec la page et retardaient la grande
       photo du haut (LCP mobile 10 s sur PageSpeed). Le comportement voulu par Malo
       reste le meme : toutes prechargees bien avant d'etre atteintes. */
    var natives=[].slice.call(root.querySelectorAll('video.hf-vs-native'));
    var near=!('IntersectionObserver' in window);
    natives.forEach(function(v){
      v.muted=true; v.loop=true;
      v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
      if(near){ v.preload='auto'; v.setAttribute('preload','auto'); }
      v.removeAttribute('autoplay');
      try{ v.pause(); }catch(e){}
    });
    function onNear(){
      if(near) return; near=true;
      natives.forEach(function(v){
        if(v.closest('.hf-clone')) return;
        if(v.preload!=='auto'){ v.preload='auto'; v.setAttribute('preload','auto'); try{ v.load(); }catch(e){} }
      });
      if(typeof playOnly==='function' && typeof activeNode==='function'){ currentEl=null; playOnly(activeNode()); }
    }
    if(!near){
      var nearObs=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ nearObs.disconnect(); onNear(); } }); }, {threshold:0, rootMargin:'1200px 0px'});
      nearObs.observe(root);
    }

    /* Points ronds (un par video) */
    var dots=[];
    function buildDots(){
      if(realCount<2) return;
      var dc=document.createElement('div'); dc.className='hf-carousel__dots';
      for(var i=0;i<realCount;i++){
        (function(idx){
          var b=document.createElement('button'); b.type='button'; b.className='hf-carousel__dot';
          b.setAttribute('aria-label','Video '+(idx+1));
          b.addEventListener('click', function(){ goToReal(idx); });
          dc.appendChild(b); dots.push(b);
        })(i);
      }
      var car=root.querySelector('.hf-carousel')||list.parentNode;
      car.appendChild(dc);
    }
    function updateDots(act){
      if(!dots.length||!act) return;
      var ri=parseInt(act.dataset.realIndex||'0',10);
      dots.forEach(function(d,i){ d.classList.toggle('is-active', i===ri); });
    }
    function goToReal(i){
      var node=realSlides[i]; if(!node) return;
      if(root.classList.contains('hf-vs--fits')){ pinned=node; updateActive(); playOnly(node); }
      else { scrollToCenter(node); }
    }

    /* Fleches prev/next (uniquement si ca defile) */
    function buildArrows(){
      if(realCount<=pvDesk) return;
      var car=root.querySelector('.hf-carousel')||list.parentNode;
      function chevron(dir){
        var ns='http://www.w3.org/2000/svg';
        var svg=document.createElementNS(ns,'svg');
        svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('fill','none'); svg.setAttribute('stroke','currentColor');
        svg.setAttribute('stroke-width','2.2'); svg.setAttribute('stroke-linecap','round'); svg.setAttribute('stroke-linejoin','round');
        var p=document.createElementNS(ns,'path'); p.setAttribute('d', dir<0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6');
        svg.appendChild(p); return svg;
      }
      function mk(dir,cls,label){
        var b=document.createElement('button'); b.type='button'; b.className='hf-carousel__nav '+cls; b.setAttribute('aria-label',label);
        b.appendChild(chevron(dir));
        b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); stepNav(dir); });
        car.appendChild(b);
      }
      mk(-1,'hf-carousel__nav--prev','Zurück');
      mk(1,'hf-carousel__nav--next','Weiter');
    }

    /* Clones pour boucle infinie (seulement si ca defile).
       REPEATS>1 : un flick rapide (mobile) peut parcourir en un seul geste
       une distance de plusieurs cartes - avec un seul jeu de clones, ce
       flick peut atteindre le vrai bord du scroll avant que le JS ait pu
       recentrer, d'ou un blocage/comportement bizarre remonte par Malo.
       On duplique plusieurs fois le jeu de clones de chaque cote pour que
       meme un flick tres rapide reste tres loin du vrai bord physique. */
    if(loop){
      var REPEATS=3;
      /* Seul le PREMIER jeu de clones (le plus proche des vraies cartes) garde
         une vraie <video> : c'est le seul qu'on puisse raisonnablement
         atteindre en usage normal, la correction de boucle intervenant bien
         avant. Les jeux de clones suivants ne servent que de filet de securite
         pour un flick tres violent : on les allege en simple <img> (le poster
         de la video) pour ne pas multiplier les elements <video> actifs dans
         la page, ce qui ralentissait le defilement VERTICAL de la page en
         passant sur cette section. */
      function makeClone(s, lite){
        var c=s.cloneNode(true);
        c.classList.add('hf-clone','hf-carousel__slide--clone');
        c.removeAttribute('data-hf-slide');
        if(lite){
          var v=c.querySelector('video.hf-vs-native');
          if(v){
            var src=v.getAttribute('poster');
            if(!src){ var srcEl=v.querySelector('source'); if(srcEl) src=srcEl.getAttribute('src'); }
            var img=document.createElement('img');
            img.className='hf-vs-native';
            img.loading='lazy'; img.alt='';
            if(src) img.src=src;
            v.parentNode.replaceChild(img, v);
          }
          var pb=c.querySelector('.hf-video-block__play'); if(pb) pb.remove();
          var sb=c.querySelector('.hf-video-block__sound'); if(sb) sb.remove();
        }
        return c;
      }
      for(var rp=0; rp<REPEATS; rp++){
        (function(lite){ slides.slice().reverse().forEach(function(s){ list.insertBefore(makeClone(s,lite),list.firstChild); }); })(rp>0);
      }
      for(var rp2=0; rp2<REPEATS; rp2++){
        (function(lite){ slides.forEach(function(s){ list.appendChild(makeClone(s,lite)); }); })(rp2>0);
      }
      requestAnimationFrame(function(){
        /* Recentrer sur la vraie video du MILIEU (celle preparee en autoplay/preload
           cote serveur), pas sur la premiere : sinon on centre une video jamais
           preparee pour l'autoplay et elle met du temps a partir, voire jamais. */
        var f=slides[Math.floor(realCount/2)];
        withoutSnap(function(){ list.scrollLeft=f.offsetLeft-list.offsetLeft-(list.clientWidth-f.clientWidth)/2; });
        /* le premier playOnly a eu lieu avant ce recentrage : la video qui joue
           n'etait pas celle du milieu. On repointe la bonne. */
        updateActive(); playOnly(activeNode());
      });

      /* Precharger TOUS les clones d'un coup serait trop lourd (avec REPEATS=3
         ca fait jusqu'a 30 videos). On les repasse en "metadata" puis on les
         precharge en vrai ("auto" + load()) des qu'ils approchent de l'ecran
         (grande marge), pour qu'ils soient prets bien avant qu'un flick rapide
         ne les atteigne, sans tout charger en meme temps au depart. */
      var cloneVids=[].slice.call(list.querySelectorAll('.hf-clone video.hf-vs-native'));
      cloneVids.forEach(function(v){ v.preload='metadata'; v.setAttribute('preload','metadata'); v.removeAttribute('autoplay'); try{ v.pause(); }catch(e){} });
      if('IntersectionObserver' in window && cloneVids.length){
        var preloadObs=new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(!en.isIntersecting) return;
            var v=en.target;
            preloadObs.unobserve(v);
            if(v.preload!=='auto'){ v.preload='auto'; v.setAttribute('preload','auto'); try{ v.load(); }catch(e){} }
          });
        }, {root:null, rootMargin:'100% 400px', threshold:0});
        cloneVids.forEach(function(v){ preloadObs.observe(v); });
      } else {
        cloneVids.forEach(function(v){ v.preload='auto'; v.setAttribute('preload','auto'); });
      }
    }

    function centerIndex(){
      var nodes=allChildren(), center=list.scrollLeft+list.clientWidth/2, best=0, bd=Infinity;
      nodes.forEach(function(nd,i){ var c=nd.offsetLeft-list.offsetLeft+nd.clientWidth/2, d=Math.abs(c-center); if(d<bd){bd=d;best=i;} });
      return best;
    }
    function activeNode(){
      var nodes=allChildren();
      if(root.classList.contains('hf-vs--fits')){
        if(pinned) return pinned;
        if(!root.classList.contains('hf-vs--no-highlight') && realCount%2===1) return nodes[Math.floor(realCount/2)];
        return nodes[Math.floor((realCount-1)/2)];
      }
      return nodes[centerIndex()];
    }
    function updateActive(){
      var nodes=allChildren(), act=activeNode();
      nodes.forEach(function(nd){ nd.classList.toggle('hf-hl-active', nd===act); });
      updateDots(act);
    }
    /* Etat pilote directement (independant des evenements scroll, pas toujours emis pour un scroll programme) */
    function setActiveNode(node){
      allChildren().forEach(function(nd){ nd.classList.toggle('hf-hl-active', nd===node); });
      updateDots(node);
      playOnly(node);
    }

    /* Autoplay muet de la video centrale.
       play() peut etre refuse (video pas encore prete, politique du navigateur) :
       on ne marque PAS la slide en pause, on retente quand la video est prete
       puis au premier geste de l'internaute. */
    var gestureArmed=false, gestureQueue=[];
    function armGesture(fn){
      gestureQueue.push(fn);
      if(gestureArmed) return; gestureArmed=true;
      var run=function(){
        document.removeEventListener('pointerdown',run,true);
        document.removeEventListener('touchstart',run,true);
        document.removeEventListener('keydown',run,true);
        window.removeEventListener('scroll',run,true);
        var q=gestureQueue; gestureQueue=[]; gestureArmed=false;
        q.forEach(function(f){ try{ f(); }catch(e){} });
      };
      document.addEventListener('pointerdown',run,true);
      document.addEventListener('touchstart',run,true);
      document.addEventListener('keydown',run,true);
      window.addEventListener('scroll',run,true);
    }
    var sectionVisible=true, watchdog=null;
    function stopWatchdog(){ if(watchdog){ clearInterval(watchdog); watchdog=null; } }
    /* Certains navigateurs ne rejettent pas play() mais ne demarrent pas pour
       autant (video pas encore bufferisee, economiseur d energie). On repasse
       toutes les 500 ms pendant 10 s tant que la video centrale reste a l arret. */
    function startWatchdog(){
      stopWatchdog();
      var n=0;
      watchdog=setInterval(function(){
        n++;
        var el=currentEl;
        if(!el||n>20){ stopWatchdog(); return; }
        if(!sectionVisible||el.classList.contains('is-paused')) return;
        var v=el.querySelector('video.hf-vs-native');
        if(!v){ stopWatchdog(); return; }
        if(v.paused){ v.muted=true; var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
        else stopWatchdog();
      },500);
    }
    function tryPlay(el,v){
      if(!v||!near) return;
      v.muted=true; v.setAttribute('muted','');
      v.setAttribute('playsinline',''); v.removeAttribute('loading');
      /* l attribut autoplay laisse le navigateur demarrer de lui-meme des qu il
         le peut, sans dependre de notre appel a play() */
      v.setAttribute('autoplay','');
      if(v.preload!=='auto'){ v.preload='auto'; try{ v.load(); }catch(e){} }
      var pr=v.play();
      if(pr&&pr.catch) pr.catch(function(){
        var again=function(){
          if(el!==currentEl||el.classList.contains('is-paused')) return;
          v.muted=true; var q=v.play(); if(q&&q.catch) q.catch(function(){});
        };
        v.addEventListener('loadeddata',again,{once:true});
        v.addEventListener('canplay',again,{once:true});
        armGesture(again);
      });
      startWatchdog();
    }

    /* Lecture : une seule video a la fois, celle au centre */
    function playOnly(el){
      if(!el) return;
      allChildren().forEach(function(nd){
        if(nd===el){ nd.classList.add('hf-vs-current'); return; }
        nd.classList.remove('hf-vs-current','is-paused');
        var ov=nd.querySelector('video.hf-vs-native'); if(ov){ try{ov.pause();}catch(e){} ov.muted=true; ov.removeAttribute('autoplay'); }
        var ob=nd.querySelector('[data-hf-sound]'); if(ob) ob.classList.remove('is-on');
      });
      if(el!==currentEl){
        el.classList.remove('is-paused');
        var nv=el.querySelector('video.hf-vs-native');
        var esb=el.querySelector('[data-hf-sound]'); if(esb) esb.classList.remove('is-on');
        currentEl=el;
        tryPlay(el,nv);
      } else {
        var cv=el.querySelector('video.hf-vs-native');
        if(cv && cv.paused && !el.classList.contains('is-paused')){ tryPlay(el,cv); }
      }
    }

    function scrollToCenter(node){
      var target=node.offsetLeft-list.offsetLeft-(list.clientWidth-node.clientWidth)/2;
      withoutSnap(function(){ animateScrollLeft(target, 480); });
      setActiveNode(node);
    }

    function layout(){
      var pv=perView();
      var fits = realCount <= pv;
      var doHighlight = (root.dataset.highlight==='true') && pv>1.2 && (!fits || realCount%2===1);
      root.classList.toggle('hf-vs--fits', fits);
      root.classList.toggle('hf-vs--scroll', !fits);
      root.classList.toggle('hf-vs--no-highlight', !doHighlight);
      if(!fits) pinned=null;
      sizeSlides();
      updateActive();
    }

    layout();
    buildDots();
    buildArrows();
    updateActive();
    playOnly(activeNode());
    /* Au chargement on doit tomber sur la video du MILIEU. En mode « tout tient a
       l'ecran » et en boucle infinie c'est deja le cas ; en defilement simple
       (mobile, pas de clones) il faut amener la slide centrale au centre. */
    if(!loop){
      requestAnimationFrame(function(){
        if(root.classList.contains('hf-vs--fits')) return;
        var mid=realSlides[Math.floor(realCount/2)]; if(!mid) return;
        withoutSnap(function(){ list.scrollLeft=mid.offsetLeft-list.offsetLeft-(list.clientWidth-mid.clientWidth)/2; });
        updateActive(); playOnly(activeNode());
      });
    }
    setTimeout(function(){ root.classList.add('hf-vs-anim'); }, 600);
    window.addEventListener('resize', function(){ layout(); playOnly(activeNode()); });

    /* Pause quand la section sort de l ecran ; reprise quand elle revient */
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ en.forEach(function(e){
        sectionVisible=e.isIntersecting;
        if(e.isIntersecting){ playOnly(activeNode()); }
        else if(currentEl){ stopWatchdog(); var v=currentEl.querySelector('video.hf-vs-native'); if(v){ try{v.pause();}catch(x){} } }
      /* marge de 400 px : la video du milieu demarre juste avant que la section
         entre a l ecran, elle est donc deja lancee quand on arrive dessus */
      }); }, {threshold:0, rootMargin:'400px 0px'}).observe(root);
    }

    var wrapping=false;
    /* Le saut de boucle doit se produire BIEN AVANT le vrai bord du scroll
       (scrollLeft===0 ou max). Trop pres du bord (l'ancien seuil de 4px), le
       saut programme entre en conflit avec le rebond elastique natif du
       navigateur (iOS Safari surtout) : les deux animations se disputent la
       position et le scroll finit par se figer, typiquement apres 1-2 tours.
       Marge large (~1 carte) = on saute largement avant d'atteindre ce bord,
       le rebond natif n'a jamais l'occasion de se declencher. */
    function wrapMargin(){ return Math.max(120, list.clientWidth*0.6); }
    function handleWrap(){
      if(!loop||wrapping) return;
      var reals=allChildren().filter(function(nd){ return nd.hasAttribute('data-hf-slide'); });
      if(!reals.length) return;
      var fr=reals[0], lr=reals[reals.length-1], max=list.scrollWidth-list.clientWidth, m=wrapMargin();
      if(list.scrollLeft<m){ wrapping=true; withoutSnap(function(){ list.scrollLeft=lr.offsetLeft-list.offsetLeft-(list.clientWidth-lr.clientWidth)/2; }); wrapping=false; }
      else if(list.scrollLeft>max-m){ wrapping=true; withoutSnap(function(){ list.scrollLeft=fr.offsetLeft-list.offsetLeft-(list.clientWidth-fr.clientWidth)/2; }); wrapping=false; }
    }
    var ticking=false;
    list.addEventListener('scroll', function(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ updateActive(); handleWrap(); ticking=false; }); }, {passive:true});
    /* Filet de secours : pendant un flick tres rapide, l'evenement "scroll" peut
       se redeclencher en continu et repousser sans cesse ce debounce de 120ms,
       qui n'arriverait alors a s'executer qu'une fois tout mouvement termine -
       trop tard si on a deja depasse le bord entre-temps. handleWrap() tourne
       donc aussi a chaque frame ci-dessus (immediat), ce debounce n'etant plus
       qu'un filet supplementaire une fois le scroll reellement stabilise. */
    list.addEventListener('scroll', function(){ clearTimeout(list._wt); list._wt=setTimeout(handleWrap,120); }, {passive:true});
    list.addEventListener('scroll', function(){ clearTimeout(list._st); list._st=setTimeout(function(){ restoreSnap(); if(!root.classList.contains('hf-vs--fits')){ pinned=null; playOnly(activeNode()); } }, 150); }, {passive:true});

    function embedSrc(url){
      var id;
      if(url.indexOf('youtu')>-1){
        var m=url.split('v=')[1]; if(!m){ m=url.split('youtu.be/')[1]||url.split('/shorts/')[1]||url.split('/embed/')[1]; }
        if(m){ id=m.split('&')[0].split('?')[0].split('/')[0]; return 'https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0&playsinline=1'; }
      }
      if(url.indexOf('vimeo.com')>-1){ var p=url.split('vimeo.com/')[1]; if(p){ id=p.split('video/').join('').split('?')[0].split('/')[0]; return 'https://player.vimeo.com/video/'+id+'?autoplay=1&title=0&byline=0&portrait=0'; } }
      return url;
    }

    root.addEventListener('click', function(e){
      /* Bouton son : uniquement sur la video centrale */
      var snd=e.target.closest('[data-hf-sound]');
      if(snd){ e.preventDefault(); e.stopPropagation();
        var sslide=snd.closest('.hf-carousel__slide'); if(sslide!==currentEl) return;
        var v=sslide.querySelector('video.hf-vs-native'); if(!v) return;
        if(v.muted){
          allChildren().forEach(function(nd){ if(nd!==sslide){ var o=nd.querySelector('video.hf-vs-native'); if(o) o.muted=true; var ob=nd.querySelector('[data-hf-sound]'); if(ob) ob.classList.remove('is-on'); } });
          v.muted=false; snd.classList.add('is-on'); var pp=v.play(); if(pp&&pp.catch) pp.catch(function(){});
        } else { v.muted=true; snd.classList.remove('is-on'); }
        snd.setAttribute('aria-label', v.muted?'Ton einschalten':'Ton ausschalten');
        return;
      }
      /* Bouton play : centre la video si non centrale, sinon toggle pause */
      var pb=e.target.closest('.hf-video-block__play');
      if(pb){ e.preventDefault(); e.stopPropagation();
        var pslide=pb.closest('.hf-carousel__slide');
        if(pslide===currentEl){
          var pv2=pslide.querySelector('video.hf-vs-native');
          if(pv2){ if(pv2.paused){ pslide.classList.remove('is-paused'); var r1=pv2.play(); if(r1&&r1.catch) r1.catch(function(){}); } else { pv2.pause(); pslide.classList.add('is-paused'); } }
          else { var pe=pslide.getAttribute('data-hf-embed'); var pc=pslide.querySelector('.hf-video-block'); if(pe&&pc&&!pc.classList.contains('is-loaded')){ loadEmbed(pc,pe); } }
        } else if(root.classList.contains('hf-vs--fits')){ pinned=pslide; updateActive(); playOnly(pslide); }
        else { scrollToCenter(pslide); }
        return;
      }
      /* Clic sur la carte : centre / joue (ou charge l embed si centrale) */
      var card=e.target.closest('.hf-video-block'); if(!card) return;
      var slide=card.closest('.hf-carousel__slide'); if(!slide) return;
      var embed=slide.getAttribute('data-hf-embed');
      if(slide!==currentEl){
        if(root.classList.contains('hf-vs--fits')){ pinned=slide; updateActive(); playOnly(slide); }
        else { scrollToCenter(slide); }
        return;
      }
      if(embed && !card.classList.contains('is-loaded')){ loadEmbed(card,embed); }
    });

    function loadEmbed(card,url){
      var f=document.createElement('iframe'); f.src=embedSrc(url);
      f.setAttribute('allow','autoplay; fullscreen; picture-in-picture'); f.setAttribute('allowfullscreen','');
      card.appendChild(f); card.classList.add('is-loaded');
    }

    /* Drag SOURIS uniquement (mode defilement).
       Au doigt on ne branche rien : le defilement horizontal est deja natif
       (overflow-x:auto + touch-action:pan-y). Brancher le drag sur le tactile
       bloquait la page : le navigateur qui reprend un geste vertical emet
       « pointercancel » et non « pointerup », donc « down » restait a true
       pour toujours et chaque pointermove suivant, n'importe ou sur la page,
       venait ecrire list.scrollLeft et contrarier le defilement. */
    var down=false,sx=0,ss=0,moved=false;
    list.addEventListener('pointerdown', function(e){
      if(e.pointerType && e.pointerType!=='mouse') return;
      if(!root.classList.contains('hf-vs--scroll')) return;
      down=true; moved=false; sx=e.clientX; ss=list.scrollLeft; list.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true; list.scrollLeft=ss-dx; });
    function endDrag(){ if(!down) return; down=false; list.classList.remove('is-dragging'); handleWrap(); }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    window.addEventListener('blur', endDrag);
    list.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);

    /* Fleches (optionnelles, si presentes dans le markup) */
    function stepNav(dir){ var nd=allChildren()[centerIndex()+dir]; if(nd) scrollToCenter(nd); }
    var prev=root.querySelector('[data-hf-prev]'), next=root.querySelector('[data-hf-next]');
    if(prev) prev.addEventListener('click', function(){ stepNav(-1); });
    if(next) next.addEventListener('click', function(){ stepNav(1); });
  }
  function boot(){ [].slice.call(document.querySelectorAll('.hf-video-slider')).forEach(initSlider); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
